import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import * as PointsActions from '../actions/points.actions';
import * as PointsApiActions from '../actions/points-api.actions';
import * as Reducers from '../reducers';
import { catchError, exhaustMap, first, mergeMap, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { forkJoin, from, interval, of } from 'rxjs';
import { Utils } from '../../../shared/utils';
import { PointsService } from '../../../tracks/services/points.service';
import { Store } from '@ngrx/store';
import { cacheLifeTime } from '../../../shared/config';
import { PointsSummary } from '../../../tracks/models/points-summary';
import { chunkArray } from '../../../core/common/functions';
import { RouteDetails } from '../../../shared/models/route-details';
import * as TracksApiActions from '../actions/tracks-api.actions';

@Injectable()
export class PointsEffects {

  // getPoints$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(PointsActions.getPoints.type),
  //     withLatestFrom(
  //       this.store$.select(Reducers.getPointsMap)
  //     ),
  //     switchMap(([action, points]) => {
  //         const params = { unitId: action['unitId'], dateFrom: action['dateFrom'], dateTo: action['dateTo'] };
  //         if (points && points.has(JSON.stringify(params))) {
  //           return of(PointsApiActions.getPointsSuccess({params: params, data: points.get(JSON.stringify(params))}))
  //         } else {
  //           return this.pointsService.getPoints(action['unitId'], action['dateFrom'], action['dateTo'])
  //             .pipe(
  //               switchMap((data) => of(PointsApiActions.getPointsSuccess({params: params, data: data}))),
  //               catchError(error => of(PointsApiActions.getPointsFailure({error})))
  //             )
  //         }
  //       }
  //     )
  //   )
  // );

  getPoints$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PointsActions.getPoints.type),
      switchMap((action) => {
        const params = {unitIds: action['unitIds'], dateFrom: action['dateFrom'], dateTo: action['dateTo']};
        const subs = [];
        // @ts-ignore
        action['unitIds']?.forEach(id => subs.push(this.pointsService.getPoints(id, action['dateFrom'], action['dateTo']).pipe(
          first(),
          catchError(err => of(new PointsSummary()))
        )));
        return forkJoin(subs).pipe(
          exhaustMap((data: PointsSummary[]) => of(PointsApiActions.getPointsSuccess({params: params, data: data, unitIds: action['unitIds']}))),
          catchError(error => of(PointsApiActions.getPointsFailure({error})))
        )
      })
    )
  );

  @Effect()
  clear = interval(cacheLifeTime).pipe(
    switchMap((action) => of(PointsActions.clearCache()))
  );

  private utils: Utils;
  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private pointsService: PointsService,
  ) {
    this.utils = new Utils();
  }
}
